"use client";

import { createContext, useContext } from "react";
import { usePortfolioAssetsInfinite } from "@/src/hooks";

interface PortfolioContextType {
  marketResult: ReturnType<typeof usePortfolioAssetsInfinite>;

  searchAsset: any;
  setSearchAsset: (asset: any) => void;

  keywords: string;
  setKeywords: (keywords: string) => void;

  searchInputActive: boolean;
  setSearchInputActive: (active: boolean) => void;
}

const PortfolioContext = createContext<PortfolioContextType | null>(null);

export function usePortfolioContext() {
  const context = useContext(PortfolioContext);
  if (!context) {
    throw new Error(
      "usePortfolioContext must be used within a PortfolioProvider",
    );
  }
  return context;
}
